import Swiper from 'swiper';

const start_slider = new Swiper('.main-slider', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: false,
  autoplay: {
    delay: 8000,
  },
  pagination: {
    el: '.main-slider-pagination',
    clickable: true, 
    renderBullet: function (index, className) {
      return '<span class="' + className + '">0' + (index + 1) + '</span>';
    }
  },
 
});


const partners_slider = new Swiper('.partners-slider', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  lazy: true,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    600: {
      slidesPerView: 2
    },
    900: {
      slidesPerView: 3
    },
  }
});

//! FIXERS
const updateSwiper = slider =>{
  setTimeout(function () {
    slider.update();
  }, 500);
};

if(start_slider.slides != undefined)
  updateSwiper(start_slider);

if(partners_slider.slides != undefined)
  updateSwiper(partners_slider);